import React from "react";

/**
 * Context to share the simple link reference information between all components
 */
 export const SingleBandLinkReferenceContext = React.createContext<Readonly<any>>({} as {});

/**
 * Context to share the sample link information that user has given
 */
 export const SingleBandLinkUserContext = React.createContext<Readonly<any>>({} as {});